const UNIT_REGEX = /^\d+/;

export const stripUnits = (value: string): number => {
	const match = value.match(UNIT_REGEX);
	if (match) {
		return parseInt(match[0], 10);
	}
	return 0;
};
